module.exports = __webpack_public_path__ + "img/urban-solar-energy.4528b24c.png";